
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"highlight-stroke",attrs:{"d":"M10 3a4 4 0 11-4 4 4 4 0 014-4m0-1a5 5 0 105 5 5 5 0 00-5-5z","fill":"#fff"}}),_c('path',{staticClass:"highlight-stroke",attrs:{"fill":"none","stroke":"#fff","stroke-miterlimit":"10","d":"M6.5 10.5l-5 5"}})])
          )
        }
      }
    